<template>
  <avs-chip
    class="min-width-120"
    color="info"
    icon="mdi-play"
    iconColor="blue"
    text-color="blue"
  >
    {{ $t("commons.status.ongoing") }}
  </avs-chip>
</template>

<script>
export default {
  name: "OngoingChip"
}
</script>
